import React, { useEffect } from 'react'
import DataTable from 'react-data-table-component';
import { Card } from 'reactstrap';
import columns from './columns';
import { getHistory } from '../../../redux/history/slices';
import { useDispatch, useSelector } from 'react-redux';
import '../../../assets/scss/components/historyTable.scss'

const HistoryTable = () => {
    const dispatch = useDispatch();
    const history = useSelector(state => state.history?.data);
    useEffect(() => {
        dispatch(getHistory());
    }, []);

    const items = Object.keys(history).map((key) => {
        return history[key];
    });

    const data = items.map((item, index) => {
        return { ...item, number: index + 1 };
    }).reverse();

    // console.log(data, 'data');

    const title = data.length > 0 ? `Saved Audios History (${data.length})` : 'No Saved Audios History';

    return (
        <>
            <DataTable
                title={title}
                columns={columns}
                data={data}
                customStyles={customStyles}
                pagination
                className="react-dataTable"
                responsive
                highlightOnHover
                paginationPerPage={5}
                paginationRowsPerPageOptions={[5, 10, 15, 20, 25]}
                dense
            />
        </>
    )
}

export default HistoryTable

const customStyles = {

    head: {
        style: {
            backgroundColor: '#000',
            fontSize: '.9em',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    },

    headCells: {
        style: {
            fontSize: '1em',
            fontWeight: 'bold',
            color: '#000',
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    },

    rows: {
        style: {
            minHeight: '20px', // override the row height
            padding: '0',
        },
    },

    cells: {
        style: {
            fontSize: '1.5em',
            paddingLeft: '0px', // override the cell padding for data cells
            paddingRight: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

        },
    },

    highlightOnHoverStyle: {
        backgroundColor: 'rgba(0,0,0,.08)',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,.08)',
        },
    },

    pagination: {
        style: {
            fontSize: '1em',
            color: '#000',
            padding: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    },
};